import "intersection-observer";
import * as React from "react";
import { Updater, IOWidget, fromJSX } from "widgets-for-react";
import { CMSState } from "../types.gen";

export type QuoteBlockNestedProps = {
  index: number
  text: string
  author?: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export function QuoteBlockNested(
  props: QuoteBlockNestedProps,
): IOWidget<CMSState, Updater<CMSState>> {
return (cmsState: CMSState) =>
    fromJSX(() => (
          <></>
          // <InView
          //   as="figure"
          //   onChange={(inView) => blockInviewHandler('quote', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          //   triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          //   threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          //   id={`io-${options && options.key ? options.key : props.index}`}
          //   className={getClassName(options, "block_classname", "")}
          //   key={options && options.key ? options.key : `block-${props.index}`}
          // >
          //   <div className={getClassName(options, "inner_classname", "py-5")}>
          //     <div className={getClassName(options, "content_classname", "text-center")}>
          //       {props.text && (
          //         <blockquote className={getClassName(options, "quote_classname", "")}>
          //           <p className={getClassName(options, "quote_text_classname", "h4")}>{props.text}</p>
          //         </blockquote>
          //       )}
          //       {props.author && <figcaption className={getClassName(options, "author_classname", "mb-3 text-muted")}><cite>— {props.author}</cite></figcaption>}
          //     </div>
          //   </div>
          // </InView>
        )
    )
}
